import ar from '@qlub-dev/qlub-kit/dist/constants/lang/ar.json';
import tr from '@qlub-dev/qlub-kit/dist/constants/lang/tr.json';
import es from '@qlub-dev/qlub-kit/dist/constants/lang/es.json';
import jp from '@qlub-dev/qlub-kit/dist/constants/lang/jp.json';
import pt from '@qlub-dev/qlub-kit/dist/constants/lang/pt.json';
import de from '@qlub-dev/qlub-kit/dist/constants/lang/de.json';
import zh from '@qlub-dev/qlub-kit/dist/constants/lang/cn.json';
import ko from '@qlub-dev/qlub-kit/dist/constants/lang/ko.json';
import ru from '@qlub-dev/qlub-kit/dist/constants/lang/ru.json';

export const getCountryNameTranslations = (lang: string) => {
    switch (lang) {
        case 'ar':
            return ar;
        case 'de':
            return de;
        case 'pt':
            return pt;
        case 'tr':
            return tr;
        case 'es':
            return es;
        case 'ja':
            return jp;
        case 'zh':
            return zh;
        case 'hk':
            return zh;
        case 'ko':
            return ko;
        case 'ru':
            return ru;
        default:
            return undefined;
    }
};
